export default {
      id: "ic_cross_menu-usage",
      viewBox: "0 0 30 30",
      url: "../dist/images/" + "sprite.svg#ic_cross_menu-usage",
      toString: function () {
        return this.url;
      }
    }